let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h0zBk")).then(() => parcelRequire('apd3M'));